export default "__VITE_ASSET__C3JFvt16__"